import { render, staticRenderFns } from "./ResolucionesHistorial.vue?vue&type=template&id=1c4cc89a&scoped=true&"
import script from "./ResolucionesHistorial.vue?vue&type=script&lang=js&"
export * from "./ResolucionesHistorial.vue?vue&type=script&lang=js&"
import style0 from "./ResolucionesHistorial.vue?vue&type=style&index=0&id=1c4cc89a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4cc89a",
  null
  
)

export default component.exports